var _ellipse, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1281,
    height: 1238,
    viewBox: "0 0 1281 1238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 640.5,
    cy: 619,
    rx: 640.5,
    ry: 619,
    fill: "#E3B7B7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 361.803,
    y1: 302.884,
    x2: 959.716,
    y2: 880.496,
    stroke: "#C03131",
    strokeWidth: 163
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M951.001 290.5L370.538 876.986",
    stroke: "#C03131",
    strokeWidth: 163
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureIcon);
export default __webpack_public_path__ + "static/media/failureIcon.f21c266cda60c6c99d94db2fffb1e8a4.svg";
export { ForwardRef as ReactComponent };